export default {
  stepper: {
    description: 'Onboarding af restaurant',
    steps: {
      confirm_email: 'Bekræft e-mailadresse',
      add_store_details: 'Tilføj dine butiksoplysninger',
      add_personal_details: 'Tilføj dine personlige oplysninger',
      add_bank_details: 'Tilføj bankoplysninger til udbetalinger',
      add_tax_details: 'Er din virksomhed momsregistreret?',
      upload_business_doc: 'Dokumentation for virksomheden',
      upload_personal_doc: 'Dokumentation for identitet',
      confirm_details: 'Bliv betalt',
    },
  },
  completed: {
    title: 'Onboarding afsluttet',
    description:
      'Din onboarding er afsluttet. Du kan til enhver tid tilføje dokumenter her, f.eks. en ny partners ID eller et fornyet ID.',
  },
  toasts: {
    failed_to_skip_verification_step: 'Trinnet til verificering kunne ikke springes over. Prøv igen',
  },
};
